import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Box, Grid, Switch, Tooltip, Typography, IconButton, Button } from "@mui/material";
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { useNavigate } from "react-router-dom";

import { useCompanyData } from "../../../hook/useCompanyData";
import { Loader } from "../../../components/Loader";
import { useOptionData } from "../../../hook/useOptionData";
import { RootState } from "../../../store/store";
import { PreviewContent } from "../../../components/PreviewContent";
import { setQuoteModels } from "../../../store/actions/userAuthActions";

export const UserQuotePreview: React.FC = () => {
	const history = useNavigate();

	const [isLoading, setIsLoading] = useState<boolean | false>(true);
	const [priceType, setPriceType] = useState<string>("dealer_price");

	const { company } = useCompanyData("dealer");
	const { options } = useOptionData("dealer");


	const quoteModels = useSelector(
		(state: RootState) => state.userAuth.quoteModels
	);

	useEffect(() => {
		setIsLoading(false);
	}, [quoteModels]);



	if (isLoading) return <Loader isLoading={isLoading} />;

	return (
		<>
			<Box sx={{ flexGrow: 1 }}>
				<Grid
					item
					xs={12}
					textAlign="center"
					sx={{ display: "flex", position: "relative" }}
					gap={2}
					alignItems="center"
					justifyContent="center"
					mb={2}
				>
					<Typography variant="h5" component="div">
						{priceType === "dealer_price" ? `${process.env.REACT_APP_DEALER_NAME} Price` : priceType}:
					</Typography>
					<Tooltip
						title={priceType === "dealer_price" ? `${process.env.REACT_APP_DEALER_NAME} Price` : "MSRP"}
					>
						<div>
							<Switch
								defaultChecked={priceType === "dealer_price" ? true : false}
								onChange={(e) => {
									if (e.target.checked) {
										setPriceType("dealer_price");
									} else {
										setPriceType("MSRP");
									}
								}}
							/>
						</div>
					</Tooltip>
				</Grid>
				<div
					id="PreviewContent"
				>
					{quoteModels && (
						<PreviewContent
							quoteModels={quoteModels}
							companyInfo={{ ...company }}
							options={options}
							priceType={priceType}
							setQuoteModels={setQuoteModels}
							isAdminPage={false}
						/>
					)}
				</div>

				<Typography align="center" mt={4.5} mb={1.5} sx={{ width: "100%" }}>
					<Button variant="outlined" onClick={() => history('/_quote_builder')}>
						Discard Changes
					</Button>
					<Button variant="contained" sx={{ ml: 3 }} onClick={() => history('/_quote_builder')}>
						Save & Return
					</Button>
				</Typography>
			</Box>
		</>
	);
};
